<template>
  <div class="page page__list">
    <div class="nav">
      <span
        :class="selected == '现金流量分析' ? 'selected' : ''"
        @click="toggle('现金流量分析')"
        >现金流量分析</span
      >
      <span>|</span>
      <span
        :class="selected == '现金流量表' ? 'selected' : ''"
        @click="toggle('现金流量表')"
        >现金流量表</span
      >
    </div>

    <div v-show="selected == '现金流量分析'">
      <year-filter-bar @change="onYearChange" ref="yearFilterBar" />
      <div class="canvas-title">{{ title }}趋势图</div>
      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
      </div>

      <div class="list-box">
        <div class="list-left">
          <div class="list-cell">
            <div class="list-cell__main">
              <div class="list-cell__index"></div>
              <div class="list-cell__toggle text-header">项目</div>
              <div class="list-cell__toggle text-header">本年累计</div>
            </div>
          </div>
          <div class="list-cell" v-for="(item, index) in list" :key="index">
            <div
              class="list-cell__main"
              :class="currentIndex == item.itemcode ? 'bg-color' : ''"
              @click="open(item, index + 1)"
            >
              <div class="list-cell__index">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="list-cell__content">
                {{ item.项目 }}
              </div>
              <div class="list-cell__toggle"><span v-if="item.本年累计 != 0 && item.本年累计 != null" v-format="'#,##0.00'">{{ item.本年累计 }}</span></div>
            </div>
          </div>
        </div>
        <div class="list-right">
          <div class="list-cell width-1220">
            <div class="list-cell__main">
              <div class="list-cell__toggle text-header">1月</div>
              <div class="list-cell__toggle text-header">2月</div>
              <div class="list-cell__toggle text-header">3月</div>
              <div class="list-cell__toggle text-header">4月</div>
              <div class="list-cell__toggle text-header">5月</div>
              <div class="list-cell__toggle text-header">6月</div>
              <div class="list-cell__toggle text-header">7月</div>
              <div class="list-cell__toggle text-header">8月</div>
              <div class="list-cell__toggle text-header">9月</div>
              <div class="list-cell__toggle text-header">10月</div>
              <div class="list-cell__toggle text-header">11月</div>
              <div class="list-cell__toggle text-header">12月</div>
            </div>
          </div>
          <div
            class="list-cell width-1220"
            v-for="(items, index2) in list"
            :key="index2"
          >
            <div
              class="list-cell__main"
              :class="currentIndex == items.itemcode ? 'bg-color' : ''"
              @click="open(items, index2 + 1)"
            >
              <div
                class="list-cell__toggle"
                v-for="(mitem, mindex) in items.monthDetail"
                :key="mindex"
              >
                <span v-format="'#,##0.00'" v-if="mitem!= 0 && mitem != null">{{ mitem }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 48px" v-show="selected == '现金流量表'">
      <year-month-filter-bar @change="searchList" ref="yearMonthFilterBar" />
      <div class="weui-cells">
        <div class="report-item font-bold">
          <div class="report-item-name">项目</div>
          <div class="report-item-year">本年累计金额</div>
          <div class="report-item-month">本月金额</div>
        </div>
        <div class="report-item" v-for="(item, index) in items" :key="index">
          <div class="report-item-name">{{ item.itemName_0 }}</div>
          <div class="report-item-year">
            <span v-if="item.balance_0 != 0 && item.balance_0 !=null" v-format="'#,##0.00'">{{ item.balance_0 || "" }}</span>
          </div>
          <div class="report-item-month">
            <span v-if="item.prebalance_0 != 0 && item.prebalance_0 !=null" v-format="'#,##0.00'">{{ item.prebalance_0 || "" }}</span>
          </div>
        </div>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">共：{{ items.length }}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import YearFilterBar from "@/components/YearFilterBar.vue";
import YearMonthFilterBar from "@/components/YearMonthFilterBar.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    YearFilterBar,
    YearMonthFilterBar,
  },
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      list: [],
      selected: "现金流量分析",
      items: [],
      year,
      opened: -1,
      chart: null,
      title: "项目",
      currentIndex: "",
    };
  },

  mounted() {
    this.searchCashflowMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchCashflowMonth() {
      let me = this;

      me.$ajax({
        url: "/api/finance/report/cashflowMonth",
        params: {
          year: me.year,
        },
      }).then(function (res) {
        if (res.success) {
          res.data.details.forEach((item) => {
            // item.itemName_0 = item.itemName_0.replace(/&nbsp;/g, '\u00A0');
            item.itemname = item.itemname.replace(/&nbsp;/g, "");
          });

          me.result = res.data;
          me.initChart(me.deal(me.result.details[37]));
          me.title = me.result.details[37].itemname;
          me.currentIndex = me.result.details[37].itemcode;

          me.initList();
        }
      });
    },
    searchList() {
      var me = this;

      let period = me.$refs.yearMonthFilterBar.yearmonth;

      me.$loading({
        url: "/api/finance/report/list",
        params: {
          reportType: "cashflow",
          page: 1,
          start: 0,
          limit: 25,
          period,
        },
      }).then(function (res) {
        if (res.success) {
          res.data.forEach((item) => {
            item.itemName_0 = item.itemName_0.replace(/&nbsp;/g, "\u00A0");
            // item.itemName_0 = item.itemName_0.replace(/&nbsp;/g, '');
          });
          me.items = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: { message: res.message, code: res.code },
          });
        }
      });
    },
    countNum: function (data) {
      let record = data,
        sum = 0;
      for (var i = 1; i < 13; i++) {
        let propName = `amount${i}`;
        if (record[propName]) {
          sum += Math.abs(Number(record[propName]));
        }
      }
      return sum;
    },
    initList() {
      let me = this,
        data = this.result.details,
        details = [],
        arr = [];
      data.map((item) => {
        let sum = me.countNum(item);
        if (
          sum > 0 ||
          item.itemcode == "16*001" ||
          item.itemcode == "16*002" ||
          item.itemcode == "16*003" ||
          item.itemcode == "16*004" ||
          item.itemcode == "16*005" ||
          item.itemcode == "16*006"
        ) {
          details.push(item);
        }
      });
      arr = details.map((item) => {
        return {
          项目: item.itemname,
          itemcode: item.itemcode,
          monthDetail: [
            item.amount1 ? item.amount1 : "",
            item.amount2 ? item.amount2 : "",
            item.amount3 ? item.amount3 : "",
            item.amount4 ? item.amount4 : "",
            item.amount5 ? item.amount5 : "",
            item.amount6 ? item.amount6 : "",
            item.amount7 ? item.amount7 : "",
            item.amount8 ? item.amount8 : "",
            item.amount9 ? item.amount9 : "",
            item.amount10 ? item.amount10 : "",
            item.amount11 ? item.amount11 : "",
            item.amount12 ? item.amount12 : "",
          ],
          本年累计: item.amount ? item.amount : "",
        };
      });

      // this.opened = -1
      this.list = arr;
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.details[37]));
        this.title = this.result.details[37].itemname;
        this.currentIndex = this.result.details[37].itemcode;
      }
    },
    initChart(data) {
      var chart = this.chart;
      // 初始化图表
      if (chart) {
        chart.changeData(data);
        return;
      }

      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });
      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        });
        if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");

      chart.render();
    },
    deal(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: "金额",
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    deal2(data) {
      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push({
          text: i + 1 < 10 ? "0" + (i + 1) + "月" : i + 1 + "月",
          index: i,
          type: "金额",
          value: item == "" ? 0 : item,
        });
      });

      return arr;
    },
    toggle(val) {
      this.selected = val;

      if (val == "现金流量表") {
        this.searchList();
      }
    },
    open(data) {
      this.initChart(this.deal2(data.monthDetail));
      this.title = data.项目;
      this.currentIndex = data.itemcode;
    },
    onYearChange(year) {
      this.year = year;
      this.searchCashflowMonth();
    },
  },
};
</script>

<style scoped>
.bg-color {
  background: #d1e9fe;
}
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
.canvas-title {
  padding-top: 10px;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  background: var(--weui-BG);
}
.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  display: flex;
}
.list-left {
  width: 246px;
  display: flex;
  flex-direction: column;
}
.list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}

.width-1220 {
  width: 1220px;
}
.list-cell {
  background-color: #fff;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.list-left > .list-cell {
  border-left: 1px solid #ebeef5;
}

.list-cell__main {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 4px 0;
}
.list-cell__index {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  width: 144px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 100px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-header {
  font-weight: bold;
  color: #000 !important;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .nav{
    display: none
  }
  .filter-bar{
    padding: 6px 0 2px 0;
  }
  .width-1220{
    width: 730px;
  }
  .list-cell__index span {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    color: #fff;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
    background-color: #c0c0c0;
  }
  .list-cell__content {
    /* flex: 1; */
    width: 144px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .list-cell__toggle {
    width: 112px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .canvas-title{
    padding-top: 0px;
  }
}
</style>